import { g as getNumberFormat } from './formatNumber-_rBNDjjP.js';

/**
 * @param {number} value The value to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 */
const formatPercentage = getNumberFormat({
  style: 'percent'
});

export { formatPercentage as f };
//# sourceMappingURL=formatPercentage-Dnud8PJ1.js.map
